
import { AdminLayout } from '@/admin/components/AdminLayout';
import AbandonedInstallmentsTable from '@/admin/components/abandoned-installments/AbandonedInstallmentsTable';

export default function AbandonedInstallmentsPage() {
  return (
    <AdminLayout
      title="Cuotas abandonadas"
      subtitle="Cuotas cuyo cobro FLUX abandonó en Lups al vencer la fecha de abandono"
    >
      <div className="max-w-6xl">
        <div className="mb-6 rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm dark:border-amber-900 dark:bg-amber-950/30">
          <p className="text-amber-800 dark:text-amber-400">
            <span className="material-symbols-outlined mr-1 align-middle text-base">info</span>
            FLUX abandona el cobro cuando vence la <code>fecha de abandono</code> que registra al crear el payment request en Lups.
            Lups no notifica abandono — la decisión es interna de FLUX. Desde acá puedes registrar notas de seguimiento del
            proceso externo (PAC manual coordinado con el banco, gestión de cobranza, aceptar pérdida). Si recuperas monto o
            aceptas pérdida, registra el movimiento como ajuste manual en el ledger MEL del comercio afectado.
          </p>
        </div>

        <AbandonedInstallmentsTable />
      </div>
    </AdminLayout>
  );
}
